export default "__VITE_ASSET__CW3WB5y6__"